var map = {
	"./gallery-wip-3d-model_00.jpg": 4906,
	"./gallery-wip-3d-model_01.jpg": 4907,
	"./gallery_00.jpg": 4908,
	"./gallery_01.jpg": 4909
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4905;